/* Color swatches linking sibling products (WoodHandLures)
   - In a product grid, only one card per model is shown (the other colors are hidden).
   - Hovering a swatch (or tapping it on a phone) switches the card to that color:
     photo, name, description, price and link. The choice stays, so clicking the
     card opens the color the customer picked.
   - Clicking a swatch with a mouse opens that color's page directly. */
(function () {
  if (window.__siblingSwatches) return;
  window.__siblingSwatches = true;

  var lastPointerType = 'mouse';
  document.addEventListener(
    'pointerdown',
    function (e) {
      lastPointerType = e.pointerType || 'mouse';
    },
    true
  );

  function cardOf(el) {
    return el.closest('.card-wrapper');
  }

  function getCardParts(card) {
    return {
      img: card.querySelector('.card__media .media > img:first-child'),
      // only the title links (direct children), not the swatch links inside the heading
      links: card.querySelectorAll('.card__heading > a'),
      summary: card.querySelector('.product-subline'),
      price: card.querySelector('.card-information > .price')
    };
  }

  function select(card, swatch) {
    if (!card || !swatch || swatch.classList.contains('is-active')) return;
    var parts = getCardParts(card);
    if (parts.img && swatch.dataset.src) {
      parts.img.setAttribute('srcset', swatch.dataset.srcset || swatch.dataset.src);
      parts.img.setAttribute('src', swatch.dataset.src);
      parts.img.setAttribute('alt', swatch.dataset.alt || '');
      parts.img.removeAttribute('loading');
    }
    parts.links.forEach(function (a) {
      a.setAttribute('href', swatch.dataset.url);
      a.textContent = swatch.dataset.title;
    });
    if (parts.summary && swatch.dataset.summary) {
      parts.summary.innerHTML = swatch.dataset.summary;
    }
    if (parts.price && swatch.dataset.priceHtml) {
      parts.price.outerHTML = swatch.dataset.priceHtml;
    }
    card.querySelectorAll('.sibling-swatch.is-active').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
    card.classList.add('is-swatch-preview');
  }

  // Desktop: hovering or keyboard-focusing a swatch selects that color (and it stays)
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.sibling-swatch');
    if (!swatch || lastPointerType === 'touch') return;
    select(cardOf(swatch), swatch);
  });
  document.addEventListener('focusin', function (e) {
    var swatch = e.target.closest && e.target.closest('.sibling-swatch');
    if (!swatch || lastPointerType === 'touch') return;
    select(cardOf(swatch), swatch);
  });

  // Phones: the first tap on a color selects it; tapping the card (or the same dot again) opens it
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.sibling-swatch');
    if (!swatch) return;
    if (lastPointerType === 'touch' && !swatch.classList.contains('is-active')) {
      e.preventDefault();
      select(cardOf(swatch), swatch);
    }
  });

  // Hide the other colors of the same model in a product grid: one card per model
  var listCounter = 0;
  function groupCards() {
    var seen = {};
    document.querySelectorAll('[data-sibling-swatches][data-group]').forEach(function (group) {
      var item = group.closest('.grid__item') || group.closest('li');
      if (!item || !item.parentElement) return;
      var list = item.parentElement;
      if (!list.dataset.swatchListId) {
        listCounter += 1;
        list.dataset.swatchListId = String(listCounter);
      }
      var key = list.dataset.swatchListId + ':' + group.dataset.group;
      if (seen[key]) {
        if (item.style.display !== 'none') item.style.display = 'none';
      } else {
        seen[key] = true;
      }
    });
  }

  // Preload the other colors' photos so switching is instant
  function preload() {
    document.querySelectorAll('.sibling-swatch').forEach(function (s) {
      if (s.dataset.src && !s.classList.contains('is-active')) {
        var i = new Image();
        i.src = s.dataset.src;
      }
    });
  }

  function init() {
    groupCards();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preload);
    } else {
      setTimeout(preload, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme re-renders the grid (filters, sorting, loading more)
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      groupCards();
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
